module.exports = __webpack_public_path__ + "img/13.45f0a4e5.jpg";